import api from "./client";

export interface CurrencyInfo {
  code: string;
  name: string;
  symbol: string;
  rate_to_usd: number;
}

export interface CurrencyCatalog {
  currencies: CurrencyInfo[];
}

export async function listCurrencies(): Promise<CurrencyCatalog> {
  const { data } = await api.get("/invoices/currencies");
  return data;
}
